const inspection = {
  inspection: "Warehouse Inspection",
  draft: "Draft",
  pending: "In Progress",
  resolved: "Completed",
  rejected: "Cancelled",
  plState: "Please select inspection order status",
  state: "Status",
  number: "Inspection Order No.",
  createdAt: "Creation Time",
  updatedAt: "Operation Time",
  planAt: "Planned Time",
  finishedAt: "Completion Time",
  remark: "Remarks",
  detail: "Details",
  add: "Add",
  saveOk: "Save Successful",
  saveErr: "Save Failed",
  del: "Delete",
  delOk: "Delete Successful",
  delErr: "Delete Failed",
  cancel: "Cancel",
  cancelTip: "Are you sure you want to cancel this inspection order?",
  cancelOk: "Cancel Successful",
  cancelErr: "Cancel Failed",
  notE: "Not Exist",
  exist: "Exist",
  partE: "Partially Exist",
  notS: "Not Satisfied",
  suitable: "Satisfied",
  partS: "Partially Satisfied",
  notInspect: "Not Inspected",
  config: "Inspection Configuration",
  needInspection: "Inspection Required",
  cycleDays: "Inspection Cycle (Days)",
  cycleDaysPlaceholder: "Leave blank for irregular/on-demand",
  content: "Inspection Content Description",
  yes: "Yes",
  no: "No",
  day: "Day",
  plsSelectIns: "Please select whether inspection is required",
  finish: "Complete",
  finishTip: "Are you sure you want to complete this inspection order?",
  finishOk: "The inspection order has been completed",
  finishErr: "Completion Failed",
  inspector: "Inspector",
  locationCode: "Location Code",
  existenceState: "Existence Status",
  complianceState: "Compliance",
  action: "Action Taken",
  inspectedAt: "Inspection Time",
  addOrder: "Add Inspection Order",
  plProduct: "Please select materials to inspect",
  plPlanAt: "Please select inspection time",
  addProduct: "Add Material",
  redPro: "Highlighted materials have no inspection configuration",
  inspectProgress: "Inspection Progress",
  inspectItem: "Inspection Item",
  attechment: "Inspection Attachment",
  submitInspect: "Submit Inspection",
  submitSucc: "Inspection submitted successfully",
  submitFail: "Inspection submission failed",
  inspect: "Inspect",
  specialHandlingAggregate: "Storage Environment Status",
  specialHandlingState: "Storage Environment Restore",
  specialHandlingRemark: "Remarks",
  notSx: "Not As Required",
  suitablex: "As Required",
  partSx: "Partially As Required",
  notInspectx: "No Action Needed",
  unFinish: "Some inspection items have not been inspected, cannot complete",
  orderCanceled: "This inspection order has been cancelled, inspection save failed",
  orderFinished: "This inspection order has been completed, inspection save failed",
  configExsist: "This requirement type already exists, no need to add",
};

export default inspection;
